<script>
import axios from 'axios';
import TaskDialog from '../../privacyAuditDetails/components/TaskDialog';

export default {
  name: 'TaskList',
  components: {
    TaskDialog,
  },
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      measureItem: null,
      task: null,
      isTaskDialogDisplayed: false,
    };
  },
  methods: {
    // toggle() {
    //   /*
    //   const i = this.inwork.indexOf(index);

    //   if (i > -1) {
    //     this.inwork.splice(i, 1);
    //   } else {
    //     this.inwork.push(index);
    //   }
    //   */
    // },
    onShowTaskDialog(task) {
      axios.get(`/measureItem?taskId=${task.id}`)
        .then((measureItem) => {
          this.measureItem = measureItem.data;
          this.task = task;
          this.isTaskDialogDisplayed = true;
        })
        .catch(() => {
          this.isTaskDialogDisplayed = false;
        });
    },
    emitUpdate() {
      this.$emit('taskListUpdate');
    },
  },
};
</script>

<template>
  <div>
    <template v-for="(item, index) in tasks">
      <v-list-tile
        :key="item.headline"
        avatar
        ripple
        @click="toggle(index)"
        v-if="item.closed==false"
      >
        <div
          class="prio"
          :class="item.priority == 2 ? 'high' : (item.priority == 1 ? 'normal' : 'low')"
        />
        <v-list-tile-content @click="onShowTaskDialog(item)">
          <v-list-tile-title v-if="item.responsibleAffiliate">
            {{ item.responsibleAffiliate }}
          </v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">
            {{ item.name }}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider
        v-if="index + 1 < tasks.length"
        :key="index" />
    </template>

    <TaskDialog
      v-if="isTaskDialogDisplayed"
      :task="task"
      :measure-item="measureItem"
      :disabled="false"
      @cancel="isTaskDialogDisplayed = false"
      @update="emitUpdate"
    />
  </div>
</template>
